export const ProjectStatusesLabels = {
  ONGOING: 'En curso',
  ONHOLD: 'En espera',
  COMPLETED: 'Completado',
}

export const ProjectStatuses = {
  ONGOING: 'ONGOING',
  ONHOLD: 'ONHOLD',
  COMPLETED: 'COMPLETED',
}

export const ProjectStatusesColors= {
  ONGOING: '#A2142F',
  ONHOLD: '#FF9E00',
  COMPLETED: '#28C184',
}
